import { defineMessage } from 'services/localization';

export const messages = {
    subsidiaryColumnName: defineMessage('subsidiary'),
    creditLimitColumnName: defineMessage('credit_limit'),
    taxCodeColumnName: defineMessage('tax_code'),
};
